import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// services 
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { SignalRService } from './../../../core/services/signal-r.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';


@Component({
  selector: 'app-i9-gen-modal',
  templateUrl: './i9-gen-modal.component.html',
  styleUrls: ['./i9-gen-modal.component.css']
})
export class I9GenModalComponent implements OnInit {
  portalSettings: any;
  formData: { [key: string]: any } = {};
  loading: boolean = false;
  count: number = 0;
  format: string;
  progressCurrent: any;
  i9List: any[];
  alert: any;
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean; adaptivePosition: boolean};
  mobileMode: boolean = false;

  constructor(portalSettingsService: PortalSettingsService, private signalRService: SignalRService, private utilityService: UtilityService, private hiringService: HiringService, private ngbActiveModal: NgbActiveModal) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.format = utilityService.getDateFormat();
    this.signalRService.establishHub('progressHub', 'sendProgressFileName');
  }

  ngOnInit(): void {
    this.signalRService.sendProgressFileNameEvent.subscribe((fileName: any) => {
      this.progressCurrent = fileName;
    });
    this.datePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false, adaptivePosition: true};
    this.mobileMode = this.utilityService.isMobileMode();
  }

  ngOnDestroy(): void {
    // Stop SignalR connection to prevent multiple connections
    this.signalRService.stopConnection();
  }

  getList() {
    if (this.formData.fromDate != null && this.formData.toDate != null) {
      this.hiringService.i9GenList(moment(this.formData.fromDate).format("YYYY/MM/DD"), moment(this.formData.toDate).format("YYYY/MM/DD")).then((response: any) => {
        this.i9List = [];
        response.forEach((val: any) => {
          this.i9List.push({ value: val.HRRMKeyID, name: val.FirstName + " " + val.LastName });
          this.count++;
        });
        this.formData.selectedEmployee = this.i9List;
      }, (errorResponse: any) => {
        this.alert = { type: "danger", msg: errorResponse?.error?.error }
      });
    }
  }

  employeeUpdate = function () {
    this.count = 0;
    this.formData.selectedEmployee.forEach((val: any) => {
      this.count++;
    });
  }

  genClicked() {
    this.loading = true;
    var employeeList = [];
    this.formData.selectedEmployee.forEach((val: any) => {
      employeeList.push(val.value);
    });

    this.hiringService.i9Gen(employeeList, moment(this.formData.fromDate).format("YYYY/MM/DD"), moment(this.formData.toDate).format("YYYY/MM/DD")).then((response: any) => {
      this.loading = false;
      if (response.success) {
        this.alert = { type: "success", msg: "All new I-9s were sent to Vista." }
      } else {
        this.alert = { type: "danger", msg: response.error }
      }
    }, (errorResponse: any) => {
      this.alert = { type: "danger", msg: errorResponse?.error?.error }
    });
  }

  closeClicked() {
    this.ngbActiveModal.close('close');
  }

  onSelectAll() {
    this.formData.selectedEmployee = this.i9List;
    this.employeeUpdate();
  }

  onClearAll() {
    this.formData.selectedEmployee = [];
    this.employeeUpdate();
  }

  closeAlert() {
    this.alert = null;
  }

}
